export function fromAthenaEvent(athenaEvent) {
    return { ...athenaEvent, _deleted: false };
}
export function toAthenaEvent(rxdbAthenaEvent) {
    return {
        id: rxdbAthenaEvent.id,
        createdAt: rxdbAthenaEvent.createdAt,
        insertedAt: rxdbAthenaEvent.insertedAt,
        userId: rxdbAthenaEvent.userId,
        sessionId: rxdbAthenaEvent.sessionId,
        app: rxdbAthenaEvent.app,
        type: rxdbAthenaEvent.type,
        categoryData: rxdbAthenaEvent.categoryData,
        data: rxdbAthenaEvent.data,
    };
}
//# sourceMappingURL=RxdbAthenaEvent.js.map